let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ZETc"), load("4aLlP"), load("KsAVd"), load("6KGrg"), load("4hZJd")]).then(() => parcelRequire('leLdu'));